import RouteTemplate from 'ember-route-template';

import { Input } from '@ember/component';
import { concat, get, uniqueId } from '@ember/helper';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import linkToState from 'ember-route-state/helpers/link-to-state.js';

import Select from 'rise-ui/components/select.gjs';
import classMod from 'rise-ui/helpers/class-mod.js';
import event from 'rise-ui/helpers/event.js';
import set from 'rise-ui/helpers/set.js';
import enter from 'rise-ui/modifiers/enter.js';
import update from 'rise-ui/modifiers/update.js';
import { singleSpaced } from 'rise-ui/utils/string.js';

export default RouteTemplate(class HelpTemplate extends Component {
  @service helpSearch;
  @service router;

  @action updateTopic(selected) {
    this.router.transitionTo('help.search', {
      queryParams: { topic: selected || undefined },
    });
  }

  @tracked searchTerm;

  @cached get queryParams() {
    return { search: singleSpaced(this.searchTerm) };
  }

  <template>
    <div class="id-help"
      {{update (set this "searchTerm") (get this.helpSearch "search")}}
    >
      <h3 class="c-page-title id-help__title qa-page-title">Help System Search</h3>

      <div class="id-help__nav">
        <div>
          <Select class="id-help__topic-select" aria-label="Select a Topic"
            onchange={{event this.updateTopic}}
            @selected={{this.helpSearch.topic}} as | select |>
            <select.Placeholder>Select a Topic</select.Placeholder>
            {{#each-in @model.helpTopicField.allowedValues as | key topic |}}
              <select.Option @value={{key}}>{{topic}}</select.Option>
            {{/each-in}}
          </Select>
        </div>
        <div class="id-help__search">
          {{#let (uniqueId) as | searchId |}}
          <label class="id-help__search-label" for={{searchId}}>Search</label>
          <span class="id-help__search-input">
            <Input class="id-help__search-input-control" id={{searchId}}
              placeholder="Search Help Pages"
              @value={{this.searchTerm}}
              {{enter (linkToState "help.search" query=this.queryParams transition=true)}}
            />
          </span>
          <div class="id-help__query-button">
            <LinksTo @route="help.search" @query={{this.queryParams}}
              title={{concat "Search" (if this.helpSearch.results.isPending " (Loading)")}}
              class={{concat "c-search__query-button-control "
                (classMod "c-search-button" this.helpSearch.results.isPending "--loading")
              }}
            >Search</LinksTo>
          </div>
          {{/let}}
        </div>
      </div>

      <div class="c-help">
        <p>
          Search will return help pages with one or more of the search terms.
          Search ignores the following words: "a", "an", "the", "with", "of",
          "for", "to", and "and".
        </p>
      </div>

      <div class="id-help__outlet">
        {{outlet}}
      </div>

    </div>
  </template>
});
